import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import {
  DxChartModule,
  DxContextMenuModule,
  DxDataGridModule,
  DxDrawerModule,
  DxSwitchModule,
  DxToastModule,
  DxToolbarModule,
  DxTooltipModule,
  DxTreeViewModule,
} from 'devextreme-angular';
import { DxiSeriesModule } from 'devextreme-angular/ui/nested';

import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AbcConfigService, AbcCoreConfigurationModule } from '@barthauer/abc/core/configuration';
import {
  CacheService,
  DataService as CoreDataService,
  ObjectSpaceService,
  PersistenceService,
  QueryService,
} from '@barthauer/abc/core/data';
import { AbcCoreAuthenticationModule, ProfileSelectionGuardService } from '@barthauer/basys/core/authentication';
import { CoreService } from 'libs/abc/core/core.service';
import { AbcToastComponent } from 'libs/abc/ui-components/src/lib/core/src/abc-toast/abc-toast.component';
import { AbcCoreContainerService } from 'libs/abc/ui-components/src/lib/core/src/abcCoreContainer.service';
import { FlexLayoutModule } from 'ngx-flexible-layout';
import { FavoriteListComponent } from './core/favorite-list/favorite-list.component';

import { RouteReuseStrategy } from '@angular/router';
import { _AbcContextMenuComponent, _AbcDrawerComponent, _AbcScrollViewComponent, _AbcSwitchComponent, _AbcToolbarComponent, _AbcTooltipComponent, _AbcTreeComponent } from '@barthauer/abc/ui-components';
import { CustomArenaModule } from '@barthauer/custom/arena';
import { environment } from '../environments/environment';
import { CoreComponent } from './core/core.component';
import { DtLoaderComponent } from './core/shared/dt-loader/dt-loader.component';
import { CustomRouteReuseStrategy } from './CustomRouteReuseStrategy';
import { AppService } from './services/app.service';
import { ScreenService } from './services/screen.service';
import { LoginComponent } from '@barthauer/custom/iddat';

@NgModule({
  declarations: [CoreComponent, AppComponent, LoginComponent],
  imports: [
    AbcCoreAuthenticationModule,
    BrowserModule,
    DxTooltipModule,
    DxToolbarModule,
    DxDrawerModule,
    DxDrawerModule,
    DxContextMenuModule,
    DxSwitchModule,
    DxTreeViewModule,
    FlexLayoutModule,
    AbcCoreConfigurationModule,
    AppRoutingModule,
    CommonModule,
    FormsModule,
    DxChartModule,
    DxiSeriesModule,
    DxDataGridModule,
    BrowserAnimationsModule,
    MatTooltipModule,
    MatIconModule,
    AbcToastComponent,
    FavoriteListComponent,
    _AbcScrollViewComponent,
    CustomArenaModule,
    DxToastModule,
    DtLoaderComponent,
    _AbcToolbarComponent,
    _AbcTooltipComponent,
    _AbcTreeComponent,
    _AbcSwitchComponent,
    _AbcContextMenuComponent,
    _AbcDrawerComponent
  ],
  providers: [
    DatePipe,
    AppService,
    ScreenService,
    AbcConfigService,
    CoreDataService,
    CacheService,
    PersistenceService,
    AbcCoreContainerService,
    CoreService,
    ObjectSpaceService,
    ProfileSelectionGuardService,
    QueryService,
    provideAppInitializer(() => {
        const initializerFn = (ConfigurationFactory)(inject(AbcConfigService));
        return initializerFn();
      }),
    { provide: RouteReuseStrategy, useClass: CustomRouteReuseStrategy },
    provideHttpClient(withInterceptorsFromDi()),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor() {
    CacheService.isCachingDisabled = true;
  }
}

export function ConfigurationFactory(globalConfig: AbcConfigService) {
  return () => {
    return new Promise((resolve) => {
      globalConfig.loadConfig(environment.appConfigUrl).then((result) => {
        resolve(result);
      });
    });
  };
}
